import React from 'react';
import "./RoundStateBox.scss";

function RoundStateBox({children, ...rest}) {
    return (
        <div className={'round-state-box'} {...rest}>{children}</div>
    );
}

export default RoundStateBox;